"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventoryComponent = void 0;
const gotti_1 = require("gotti");
const Constants_1 = require("../../../Shared/Constants");
class InventoryComponent extends gotti_1.Component {
    constructor() {
        super(Constants_1.SYSTEMS.INVENTORY);
        this.itemsByName = {};
    }
    addItem(itemName, data) {
        this.emit('added-item', { itemName, data });
        if (itemName in this.itemsByName) {
            this.itemsByName[itemName]++;
        }
        else {
            this.itemsByName[itemName] = 1;
        }
        return true;
    }
}
exports.InventoryComponent = InventoryComponent;
//# sourceMappingURL=module.js.map